import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Vendor } from '~/features/vendor/types/vendor.type';

/**
 * 벤더 상세 조회
 * @description 벤더 상세 정보를 조회합니다
 * @endpoint GET /admin/vendors/:id
 * @param id - 벤더 ID
 * @returns 벤더 정보
 */
export function getVendorApi(id: number) {
  return axiosInstance.get<ApiResponse<Vendor>>(`/admin/vendors/${id}`);
}
